export * from "./exports-lit.js";
export * from "./exports-standard.js";
export * from "./exports-deprecated-components.js";
export * from "./exports-deprecated-names-remap.js";
let version = "7.32.0";
if (Number.isNaN(parseInt(version, 10))) {
  version = "next";
}
window.omniUIVersions = window.omniUIVersions || [];
window.omniUIVersions.push(version);
const breakingChangeWarning = (versions) => {
  return !versions.map((v) => v.slice(0, 1)).every((v, i, arr) => v === arr[0]);
};
if (window.omniUIVersions.length > 1 || window.litHtmlVersions.length > 1 || window.litElementVersions.length > 1) {
  console.warn(
    `Omni UI: found multiple versions of one of the following base libraries:

      omni-ui (${window.omniUIVersions.join(", ")})
      lit-element (${window.litElementVersions.join(", ")})
      lit-html (${window.litHtmlVersions.join(", ")})
    `
  );
  if (breakingChangeWarning(window.omniUIVersions))
    console.warn(`You have different major versions of Omni-UI loaded. This may cause unexpected behavior.`);
}
//# sourceMappingURL=index.js.map
